import React, { useState } from 'react';
import Layout from '../layout/Layout';
import { PrivateAxios } from '../../request/axios';
import { toast } from 'react-toastify';

const CreerUG = () => {
    const [ugName, setUgName] = useState('');
    const [ugDescription, setUgDescription] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const payload = {
            nom: ugName,
            description: ugDescription,
        };

        try {
            await PrivateAxios.post('/admin/ug', payload);
            toast.success('UG créée avec succès!');
            setUgName('');
            setUgDescription('');
        } catch (error) {
            toast.error('Erreur lors de la création de l\'UG.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Layout>
            <h1 className="text-black text-3xl font-bold mb-6 text-center">Créer une UG</h1>

            <div className="flex justify-center">
                <form
                    onSubmit={handleSubmit}
                    className="w-full max-w-md p-8 bg-white rounded-lg shadow-md transition-all duration-500 hover:shadow-lg"
                >
                    {/* Champ Nom */}
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="ugName">
                            Nom de l'UG
                        </label>
                        <input
                            id="ugName"
                            type="text"
                            value={ugName}
                            onChange={(e) => setUgName(e.target.value)}
                            placeholder="Entrez le nom de l'UG"
                            required
                            className="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
                        />
                    </div>

                    {/* Champ Description */}
                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="ugDescription">
                            Description de l'UG
                        </label>
                        <textarea
                            id="ugDescription"
                            value={ugDescription}
                            onChange={(e) => setUgDescription(e.target.value)}
                            placeholder="Entrez une description"
                            required
                            className="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
                            rows="4"
                        />
                    </div>

                    {/* Bouton de soumission */}
                    <div className="flex items-center justify-center">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className={`px-4 py-2 bg-blue-600 text-white font-bold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none transition-all duration-300 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                            {isSubmitting ? 'Création en cours...' : 'Créer l\'UG'}
                        </button>
                    </div>
                </form>
            </div>
        </Layout>
    );
};

export default CreerUG;
